import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from './api.service';
import { map } from 'rxjs';
import { PasswordRecoveryService } from '../features/auth/password-recovery.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const api = inject(ApiService);
  const router = inject(Router);

  return api.waitForAuthInitialization().pipe(
    map((status) => {
      if (status === 'initializing') return false;
      if (status === 'unauthenticated') {
        return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
      }

      const requiresMobile = !api.authenticatedUser()?.mobile;
      if (requiresMobile && state.url !== '/complete-mobile') {
        return router.createUrlTree(['/complete-mobile']);
      }
      if (!requiresMobile && state.url === '/complete-mobile') {
        return router.createUrlTree(['/account']);
      }
      return true;
    }),
  );
};

export const guestGuard: CanActivateFn = () => {
  const api = inject(ApiService);
  const router = inject(Router);

  return api.waitForAuthInitialization().pipe(
    map((status) => {
      if (status === 'initializing') return false;
      if (status === 'unauthenticated') return true;

      const requiresMobile = !api.authenticatedUser()?.mobile;
      return router.createUrlTree([requiresMobile ? '/complete-mobile' : '/account']);
    }),
  );
};

export const recoveryChallengeGuard: CanActivateFn = () => {
  const recovery = inject(PasswordRecoveryService);
  const router = inject(Router);
  return recovery.reference()
    ? true
    : router.createUrlTree(['/forgot-password'], { queryParams: { notice: 'challenge-required' } });
};

export const recoveryAuthorizationGuard: CanActivateFn = () => {
  const recovery = inject(PasswordRecoveryService);
  const router = inject(Router);
  return recovery.authorization()
    ? true
    : router.createUrlTree(['/forgot-password'], { queryParams: { notice: 'authorization-required' } });
};

export const recoverySuccessGuard: CanActivateFn = () => {
  const recovery = inject(PasswordRecoveryService);
  const router = inject(Router);
  return recovery.isComplete()
    ? true
    : router.createUrlTree(['/forgot-password'], { queryParams: { notice: 'challenge-required' } });
};
